import { css } from "styled-components";

import {
  Breakpoints,
  ThemeType
} from "../theme";

/**
 * This will parse a breakpoint string (i.e. -500) and return
 * the operation needed to generate a media query
 * @param {string} breakpoint
 */
const parseBreakpoint = (breakpoint: string): { lt?: string; gt?: string; range?: string[] } => {
  switch (breakpoint.charAt(0)) {
    // less than
    case "-":
      return { lt: breakpoint.substring(1) };
    // more than
    case "+":
      return { gt: breakpoint.substring(1) };
    // range
    default: {
      const range = breakpoint.split("-");

      if (range.length !== 2) {
        console.error("Invalid breakpoint range. The proper syntax for a range is: min-max");
      }

      return { range };
    }
  }
};

/**
 * Generates a media query from a breakpoint operation
 *
 * @param {Object} operation
 */
export const media = (operation: { lt?: string; gt?: string; range?: string[] }) => {
  if (operation.lt) {
    return `@media (max-width: ${operation.lt}px)`;
  } else if (operation.gt) {
    return `@media (min-width: ${operation.gt}px)`;
  } else if (operation.range) {
    return `@media (min-width: ${operation.range[ 0 ]}px) and (max-width: ${operation.range[ 1 ]}px)`;
  }

  return "";
};

/**
 * Generates valid CSS media queries from a component's props
 *
 * @param {Object} props
 */
export const breakpoint = (breakpoint: keyof Breakpoints, theme: ThemeType) => {
  if (!breakpoint) return null;

  return css`
    ${media(parseBreakpoint(theme.breakpoints[ breakpoint ]))}
  `;
};
